
























































































import { Component, mixins } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import { Prop } from 'vue-property-decorator'
import RenderProps from '@/modules/shared/components/shared/utils/RenderProps.vue'

export type ConfirmDialogRenderProps = {
  onOKClick: ConfirmDialog['onOKClick']
  onCancelClick: ConfirmDialog['onCancelClick']
}

@Component({
  components: { RenderProps, BaseButton, BaseInput }
})
export default class ConfirmDialog extends mixins<DialogMixin>(DialogMixin) {
  @Prop() readonly icon!: string
  @Prop() readonly noIcon!: boolean
  @Prop() readonly iconColor!: string
  @Prop() readonly title!: string
  @Prop() readonly message!: string
  @Prop() readonly content!: Function
  @Prop({ default: 'تایید' }) readonly confirmBtnLabel!: string
  @Prop({ default: 'انصراف' }) readonly cancelBtnLabel!: string
  @Prop({ default: false }) readonly isAlert!: boolean
  @Prop({ default: false }) readonly isAsync!: boolean
  @Prop({ default: false }) readonly loading!: boolean

  onOKClick() {
    this.$emit('ok')
    if (!this.isAsync) this.hide()
  }

  get props() {
    return {
      onOKClick: this.onOKClick,
      onCancelClick: this.onCancelClick
    }
  }
}
